<template>
  <div class="rt60">
    <!-- <top-nav></top-nav> -->
    <banner :child-data="fdata"></banner>
    <div id="about-main" class="bgrow " data-ani="">
      <div class="container">
        <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-1>
                <div class="panel-heading clearfix" role="tab" id="headingOne">
                  <div class="headingOne_left pull-left">
                    <h4 class="panel-title">{{$t('SocialH0')}}</h4>
                    <p>
                      <span>{{$t('SocialP0')}}</span>
                    </p>
                  </div>
                  <div class="headingOne_right pull-right">
                    <a
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <span class="glyphicon glyphicon-chevron-down"></span>
                    </a>
                  </div>
                </div>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div class="panel-body">
                  <h3>{{$t('SocialSecH0')}}</h3>
                  <p>{{$t('SocialSecP10')}}</p>
                  <p>{{$t('SocialSecP0')}}</p>
                  <p>{{$t('SocialSecP01')}}</p>
                  <h3>{{$t('SocialSecH01')}}</h3>
                  <p>{{$t('SocialSecP010')}}</p>
                  <p>{{$t('SocialSecP011')}</p>
                  <p>{{$t('SocialSecP012')}}</p>
                  <a href="mailto:recruitment@neucore.com">
                    <h3 class="email">{{$t('SocialSecEmail')}}</h3>
                  </a>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1  " data-ani="">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-2>
                <div role="tab" id="headingOne" class="panel-heading clearfix">
                  <div class="headingOne_left pull-left">
                    <h4
                      class="panel-title"
                    >{{$t('SocialH1')}}</h4>
                    <p>
                      <span>{{$t('SocialP1')}}</span>
                    </p>
                  </div>
                  <div class="headingOne_right pull-right">
                    <a
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseOne1"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <span class="glyphicon glyphicon-chevron-down"></span>
                    </a>
                  </div>
                </div>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div class="panel-body">
                  <h3>{{$t('SocialSecH10')}}</h3>
                  <p>{{$t('SocialSecP10')}}</p>
                  <p>{{$t('SocialSecP11')}}</p>
                  <p>{{$t('SocialSecP12')}}</p>
                  <h3>{{$t('SocialSecH11')}}</h3>
                  <p>{{$t('SocialSecP110')}}</p>
                  <p>{{$t('SocialSecP111')}}</p>
                  <p>{{$t('SocialSecP112')}}</p>
                  <p>{{$t('SocialSecP113')}}</p>
                  <p>{{$t('SocialSecP114')}}</p>
                  <p>{{$t('SocialSecP115')}}</p>
                  <a href="mailto:recruitment@neucore.com">
                    <h3 class="email">{{$t('SocialSecEmail')}}</h3>
                  </a>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-3>
                <div role="tab" id="headingOne" class="panel-heading clearfix">
                  <div class="headingOne_left pull-left">
                    <h4 class="panel-title">{{$t('SocialH2')}}</h4>
                    <p>
                      <span>{{$t('SocialP2')}}</span>
                    </p>
                  </div>
                  <div class="headingOne_right pull-right">
                    <a
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseOne2"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <span class="glyphicon glyphicon-chevron-down"></span>
                    </a>
                  </div>
                </div>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div class="panel-body">
                  <h3>{{$t('SocialSecH20')}}</h3>
                  <p>{{$t('SocialSecP20')}}</p>
                  <p>{{$t('SocialSecP21')}}</p>
                  <p>{{$t('SocialSecP22')}}</p>
                  <h3>{{$t('SocialSecH21')}}</h3>
                  <p>{{$t('SocialSecP210')}}</p>
                  <p>{{$t('SocialSecP211')}}</p>
                  <p>{{$t('SocialSecP212')}}</p>
                  <p>{{$t('SocialSecP213')}}</p>
                  <p>{{$t('SocialSecP214')}}</p>
                  <p>{{$t('SocialSecP215')}}</p>
                  <p>{{$t('SocialSecP216')}}</p>
                  <p>{{$t('SocialSecP217')}}</p>
                  <p>{{$t('SocialSecP218')}}</p>
                  <a href="mailto:recruitment@neucore.com">
                    <h3 class="email">{{$t('SocialSecEmail')}}</h3>
                  </a>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
    <!-- <footer-bot></footer-bot> -->
  </div>
</template>

<script>
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import "../../public/css/font-awesome.css";
// import '../../public/css/bootstrap.css'
import { mapMutations } from "vuex";

export default {
  name: "joinUsDetail",
  data() {
    return {
      fdata: {
        h1: "Social recruitment",
        h2:
          "We hope to enhance the relationship between people and smart devices through our own products.",
        style: {
          background:
            "url(../img/join_social/banner-career.jpg) no-repeat center",
          backgroundSize: "100% 100%"
        }
      }
    };
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    ...mapMutations(["editMenu"]),
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  },
  mounted() {
    this.editMenu("joinUs");
    // window.console.log(this.$route.query.cate)
    if (this.$route.query.cate == "school") {
      this.fdata.h1 = "School recruitment";
    } else {
      this.fdata.h1 = "Social recruitment";
    }
  }
};
</script>

<style>
@font-face {
  font-family: "Glyphicons Halflings";

  src: url("../../public/fonts/glyphicons-halflings-regular.eot");
  src: url("../../public/fonts/glyphicons-halflings-regular.eot")
      format("embedded-opentype"),
    url("../../public/fonts/glyphicons-halflings-regular.woff") format("woff"),
    url("../../public/fonts/glyphicons-halflings-regular.ttf")
      format("truetype"),
    url("../../public/fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular")
      format("svg");
}
.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: normal;
  line-height: 1;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

blockquote {
  border: none;
}

.w20 {
  width: 25%;
}
.panel-default > .panel-heading {
  padding: 20px;
  display: flex;
  align-items: center;
}
.panel-group .panel {
  margin-bottom: 20px;
}
.panel-title {
  font-weight: 600;
  font-size: 20px;
}
.glyphicon.glyphicon-chevron-down {
  font-size: 30px;
}
.headingOne_left p {
  margin: 0;
  margin-top: 12px;
}
.headingOne_right {
  flex: 1;
  text-align: right;
}
#about-main {
  padding-bottom: 30px;
  margin-top: 80px;
}

.company-develop {
  width: 60%;
  margin: 0 auto;
}

.company-develop #myTabs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.company-develop #myTabs li {
  flex: 1;
  text-align: center;
}

[class^="icon-"],
[class*=" icon-"] {
  font-family: icomoon;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  font-size: 100%;
  padding: 0;
  margin: 0;
}

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

a {
  color: #2fa0ec;
  text-decoration: none;
  outline: 0;
}

.htmleaf-container {
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}

.htmleaf-content {
  font-size: 150%;
  padding: 1em 0;
}

.htmleaf-content h2 {
  margin: 0 0 2em;
  opacity: 0.1;
}

.htmleaf-content p {
  margin: 1em 0;
  padding: 5em 0 0;
  font-size: 0.65em;
}

.bgcolor-1 {
  background: #f0efee;
}

.bgcolor-2 {
  background: #f9f9f9;
}

.bgcolor-3 {
  background: #e8e8e8;
}

.bgcolor-4 {
  background: #2f3238;
  color: #fff;
}

.df {
  /* background: white; */
  /* background: beige;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 60px 0px;
    padding-bottom: 0;
    background-clip: content-box; */
}
h3 {
  margin-top: 0;
}
.bgrow {
  background: url(../../public/img/join_us/bg-diwen.svg) no-repeat center top;
  background-size: 100%;
}
.col-md-4 {
  padding-bottom: 0;
}
.box_shadow {
  height: 180px;
  box-shadow: 0 5px 30px 0 rgba(77, 138, 221, 0.15);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 80px 0px;
  padding-bottom: 0;
  background-clip: content-box;
}
.spandf {
  display: flex;
  flex-direction: column;
  line-height: 40px;
  font-size: 20px;
  margin-left: 30px;
}
.spandf span:nth-child(1) {
  font-weight: 600;
}
.spandf span:nth-child(2) {
  font-size: 16px;
}
.bgcolor-5 {
  background: #df6659;
  color: #521e18;
}

.bgcolor-6 {
  background: #2fa8ec;
}

.bgcolor-7 {
  background: #d0d6d6;
}

.bgcolor-8 {
  background: #3d4444;
  color: #fff;
}

.bgcolor-9 {
  background: #ef3f52;
  color: #fff;
}

.bgcolor-10 {
  background: #64448f;
  color: #fff;
}

.bgcolor-11 {
  background: #3755ad;
  color: #fff;
}

.bgcolor-12 {
  background: #3498db;
  color: #fff;
}

.htmleaf-header {
  padding: 1em 190px;
  letter-spacing: -1px;
  text-align: center;
}

.htmleaf-header h1 {
  font-weight: 600;
  font-size: 2em;
  line-height: 1;
  margin-bottom: 0;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.htmleaf-header h1 span {
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
  display: block;
  font-size: 60%;
  font-weight: 400;
  padding: 0.8em 0 0.5em;
  color: #c3c8cd;
}

.htmleaf-demo a {
  color: #1d7db1;
  text-decoration: none;
}

.htmleaf-demo {
  width: 100%;
  padding-bottom: 1.2em;
}

.htmleaf-demo a {
  display: inline-block;
  margin: 0.5em;
  padding: 0.6em 1em;
  border: 3px solid #1d7db1;
  font-weight: 700;
}

.htmleaf-demo a:hover {
  opacity: 0.6;
}

.htmleaf-demo a.current {
  background: #1d7db1;
  color: #fff;
}

.htmleaf-links {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  font-size: 1.5em;
  text-align: center;
}

.htmleaf-links::after {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -1px;
  width: 2px;
  height: 100%;
  background: #dbdbdb;
  content: "";
  -webkit-transform: rotate3d(0, 0, 1, 22.5deg);
  transform: rotate3d(0, 0, 1, 22.5deg);
}

.htmleaf-icon {
  display: inline-block;
  margin: 0.5em;
  padding: 0;
  width: 1.5em;
  text-decoration: none;
}

.htmleaf-icon span {
  display: none;
}

.htmleaf-icon:before {
  margin: 0 5px;
  text-transform: none;
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  font-family: icomoon;
  line-height: 1;
  speak: none;
  -webkit-font-smoothing: antialiased;
}

.htmleaf-footer {
  width: 100%;
  padding-top: 10px;
}

.htmleaf-small {
  font-size: 0.8em;
}

.center {
  text-align: center;
}

.related {
  color: #fff;
  background: #333;
  text-align: center;
  font-size: 1.25em;
  padding: 0.5em 0;
  overflow: hidden;
}

.related > a {
  vertical-align: top;
  width: calc(100% - 20px);
  max-width: 340px;
  display: inline-block;
  text-align: center;
  margin: 20px 10px;
  padding: 25px;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.related a {
  display: inline-block;
  text-align: left;
  margin: 20px auto;
  padding: 10px 20px;
  opacity: 0.8;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  -webkit-backface-visibility: hidden;
}

.related a:hover,
.related a:active {
  opacity: 1;
}

.related a img {
  max-width: 100%;
  opacity: 0.8;
  border-radius: 4px;
}

.related a:hover img,
.related a:active img {
  opacity: 1;
}

.related h3 {
  font-family: microsoft yahei, sans-serif;
}

.related a h3 {
  font-weight: 300;
  margin-top: 0.15em;
  color: #fff;
}

.icon-htmleaf-home-outline:before {
  content: "\e5000";
}

.icon-htmleaf-arrow-forward-outline:before {
  content: "\e5001";
}

@media screen and (max-width: 50em) {
  .htmleaf-header {
    padding: 3em 10% 4em;
  }

  .htmleaf-header h1 {
    font-size: 2em;
  }
}

@media screen and (max-width: 40em) {
  .htmleaf-header h1 {
    font-size: 1.5em;
  }
}

@media screen and (max-width: 30em) {
  .htmleaf-header h1 {
    font-size: 1.2em;
  }
}

.glyphicon-chevron-down:before {
  content: "\e114";
}
.headingOne_left {
  text-align: left;
}
.headingOne_right a:hover {
  color: white;
}
.btn-secondary:hover:hover {
  color: #fff;
  background-color: lightblue;
  border-color: #545b62;
}
.btn-secondary {
  background-color: #f5f5f5;
  border-color: #ddd;
  border: 0;
  color: black;
}
.card-body {
  text-align: left;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: lightblue;
  border-color: #545b62;
  border: 0;
}
.btn-secondary:focus,
.btn-secondary.focus {
  color: #fff;
  background-color: lightblue;
  border-color: #545b62;
  border: 0;
}
.rt60 {
  position: relative;
  top: -60px;
    margin-bottom: -60px;
}
</style>